/* eslint-disable max-len */
import React from 'react';
function Marking() {
    return (React.createElement("g", null,
        React.createElement("path", { d: "M1.5 5H13.5001V7H1.5V5ZM1.5 9H13.5001V11H1.5V9ZM1.5 15H9.50007V13H1.5V15ZM22.4996 12L20.9996 10.5L15.5096 16L12.4995 13L10.9995 14.5L15.5096 19L22.4996 12Z" })));
}
export default Marking;
